import React from 'react'
import styled from 'styled-components'
import Container from '../container'

const Outer = styled.div`
  background: linear-gradient(180deg, rgba(0,0,0,1) 0%, rgba(0,0,0,1) 50%, rgba(255,255,255,1) 50%);
  padding-bottom: 30px;
  padding-top: 30px;
  border-bottom: ${props => props.border ? '1px solid #000' : 'none'};
`

const Inner = styled.div`
  width: calc(100vw - 64px);
  margin: 0 auto;
`

const BlackToWhite = ({children, border}) => {
  return (
    <Outer border={border}>
      <Inner>
      {children}
      </Inner>
    </Outer>
  )
}

export default BlackToWhite
